module.exports = __webpack_public_path__ + "img/Busy_Corner@1x.a1bb61d6.webp";